<div *ngIf="isLoading | async">
  <div class="loader-sec text-center">
    <div id="preloader">
      <p-progressSpinner></p-progressSpinner>
      <p>Loading...</p>
    </div>
  </div>
</div>
